"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutcomeParameterValue = void 0;
// TODO Remove after PLAT-2815 release
const getOutcomeParameterValue = ({ parameterType, eventProbability, }) => {
    var _a, _b;
    return (_b = (_a = eventProbability === null || eventProbability === void 0 ? void 0 : eventProbability.parameters) === null || _a === void 0 ? void 0 : _a.find((p) => p.type === parameterType)) === null || _b === void 0 ? void 0 : _b.value;
};
exports.getOutcomeParameterValue = getOutcomeParameterValue;
//# sourceMappingURL=getOutcomeParameterValue.js.map